import Nav from "../Components/Nav";
import Item from "../Components/Sub-Components/Item";
import { motion } from "framer-motion";

const menu1 = "89,00 DKK";
const menu2 = "69,00 DKK";
const menu3 = "105,00 DKK";
const menu4 = "79,00 DKK";
const menu5 = "79,00 DKK";
const menu6 = "89,00 DKK";
const menu7 = "105,00 DKK";
const pommes = "40,00 DKK";
const nuggetspris = "30,00 DKK";

const Menuer = () => {
  return (
    <div>
      <Nav />
      <div className=" relative h-[100vh] gap-5 max-h-screen">
        <motion.p
          initial={{ opacity: 0, y: "-30" }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-white text-center text-3xl Bebas mt-[13vh] border-b"
        >
          Menuer
        </motion.p>

        <motion.div className="mt-[2vh] mb-10 overflow-y-auto w-full flex flex-wrap justify-center items-center">
          <motion.div
            initial={{ opacity: 0, x: "-30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <Item
              img="/Assets/fiskefilet&pommes.jpg"
              name="Fiskefilet m. Pommes frites"
              desc="2 stks inkl. remoulade"
              
              price={menu1}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: "30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 1 }}
          >
            <Item
              img="/Assets/3-2.jpg"
              name="Pommes frites m."
              desc="7 stk Chicken Nuggets inkl. dip"
              
              price={menu2}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: "30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 2 }}
          >
            <Item
              img="/Assets/3-4.jpg"
              name="Fish'n Chips m."
              desc="Tartar sauce"
              
              price={menu3}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: "-30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 2.5 }}
          >
            <Item
              img="/Assets/3-5.jpg"
              name="Kebabmix"
              desc="Rå løg, cremefraiche dressing/Karry-ketchup"
              
              price={menu4}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: "-30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 2.5 }}
          >
            <Item
              img="/Assets/pølsemix.jfif"
              name="Pølsemix"
              desc="Agurkesalat, rå løg, karry-ketchup/cremefraiche"
              
              price={menu5}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: "-30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <Item
              img="/Assets/menu6.jpg"
              name="5 stk. Krydret Hotwings m. Pommes frites"
              // new="/Assets/news.png"
              desc="Valgfri dip"
              
              price={menu6}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: "-30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <Item
              img="/Assets/template.png"
              name="8 stk. Indbagte rejer"
              // new="/Assets/news.png"
              desc="med hvidløgs dressing, pommes frites & salat"
              
              price={menu7}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: "-30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 1.5 }}
          >
            <Item
              img="/Assets/pommes2.jpg"
              name="Pommes Frites"
              desc="inkl. dip"
              price={pommes}
            />
          </motion.div>
        
          <motion.div
            initial={{ opacity: 0, x: "-30" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 2.5 }}
          >
            <Item
              img="/Assets/3-3.jpg"
              name="Chicken Nuggets"
              desc="5 stk inkl. Dip"
              price={nuggetspris}
            />
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Menuer;
